const config = require("../appConf");

const ResourceClient = {
  typeResources: "DAM_RESOURCE",
  typeLink: "LINK",
  typeEvent: "TRAINING_RESOURCE",
  typeBook: "BOOK_ID",
  typeTimeBook: "TIME_ID",

  buildHeaders(token) {
    return {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };
  },

  debug() {
    return process && process.env === "development";
  },

  /**
   * Generic method to retrieve the full resources tree
   *
   * @param token : authentication token
   */
  async _getTree(token) {
    const url = `${config.url}/folder/tree?include_resource=true`;
    try {
      const response = await (await fetch(url, { headers: this.buildHeaders(token) })).json();
      return response;
    } catch (e) {
      return {};
    }
  },

  /**
   * Generic method to retrieve the user resources
   *
   * @param token : authentication token
   */
  async _getUserResources(token, origin) {
    let params = "";
    if (origin) {
      params = `?origin=${origin}`;
    }
    const url = `${config.url}/user_resource/${params}`;
    try {
      const response = await (await fetch(url, { headers: this.buildHeaders(token) })).json();
      return response;
    } catch (e) {
      return {};
    }
  },

  /**
   * Save a single bookmark in the given folder
   *
   * @param {*} token : authentication token
   * @param {*} object : bookmark object to save
   * @param {*} folderId : folder id to save object info (defalt is null == root)
   */
  async _saveObject(token, object, folderId) {
    const url = `${config.url}/user_resource`;
    const saved = { ...object };
    if (this.debug()) console.log("#### SOURCE BOOKMARK", object);
    if (this.debug()) console.log("#### SOURCE BOOKMARK - STRING", JSON.stringify(object));
    if (folderId) {
      saved.folder = folderId;
    }
    const response = await (
      await fetch(url, { headers: this.buildHeaders(token), method: "POST", body: JSON.stringify(saved) })
    ).json();
    if (this.debug()) console.log("#### SAVED BOOKMARK", response);
    if (this.debug()) console.log("#### SAVED BOOKMARK - STRING", JSON.stringify(response));
    return response;
  },

  /**
   * Delete a bookmark
   *
   * @param {*} token : authentication token
   * @param {*} objectId : bookmark id
   */
  async _deleteObject(token, objectId) {
    const url = `${config.url}/user_resource/${objectId}`;
    const response = await (await fetch(url, { headers: this.buildHeaders(token), method: "DELETE" })).json();
    return response;
  },

  /**
   * Get the list of resources in the root folder
   *
   * @param {*} token : authentication token
   */
  async getAll(token) {
    const all = await this._getTree(token);
    if (this.debug()) console.log("#### LOADED BOOKMARKS", all);
    if (this.debug()) console.log("#### LOADED BOOKMARKS - STRING", JSON.stringify(all));
    if (!all.resources) return {};
    return {
      events: all.resources.filter(item => item.type === ResourceClient.typeEvent),
      posts: all.resources.filter(item => item.type === ResourceClient.typeLink),
      resources: all.resources.filter(item => item.type === ResourceClient.typeResources),
      books: all.resources.filter(item => item.type === ResourceClient.typeBook),
      timeBooks: all.resources.filter(item => item.type === ResourceClient.typeTimeBook),
    };
  },

  /**
   * Return the base name (event/post/resource/book/timeBook) of the state attribute given a a bookmark type.
   *
   * @param {*} bookmarkType : bookmark type string
   */
  getAttributeByType(bookmarkType) {
    if (bookmarkType === ResourceClient.typeEvent) return "event";
    if (bookmarkType === ResourceClient.typeLink) return "post";
    if (bookmarkType === ResourceClient.typeResources) return "resource";
    if (bookmarkType === ResourceClient.typeBook) return "book";
    if (bookmarkType === ResourceClient.typeTimeBook) return "timeBook";
    return null;
  },

  /**
   * Delete bookmark
   *
   * @param {*} token : authentication token
   * @param {*} bookmarkId : bookmark Id
   */
  async deleteObject(token, bookmarkId) {
    const deleted = await this._deleteObject(token, bookmarkId);
    if (!deleted) return {};
    return deleted;
  },
  async searchResource() {}, // eslint-disable-line no-empty-function

  /**
   * Get the list of resources in the root folder
   *
   * @param {*} token : authentication token
   */
  async getResources(token) {
    const all = await this._getTree(token);
    if (!all.resources) return [];
    return all.resources.filter(item => item.type === this.typeResources);
  },

  /**
   * Save a DAM resource object
   *
   * @param {*} token : authentication token
   * @param {*} resource : DAM resource object
   * @param {*} bookmarkFrom : website source
   */
  async saveResource(token, resource, bookmarkFrom) {
    if (!bookmarkFrom && this.debug()) console.log("#### Bookmark origin not set!");
    const savedObject = {
      title: resource.title,
      type: this.typeResources,
      data_from: bookmarkFrom,
      origin: bookmarkFrom.code,
      data_url: resource.share_url,
      data_obj_id: resource.resource_uuid,
      data_url_from: document.location.href,
      payload: resource,
    };
    const saved = await this._saveObject(token, savedObject);
    if (!saved) return {};
    return saved;
  },

  /**
   * Get the list of dealive post in the root folder
   *
   * @param {*} token : authentication token
   */
  async getDeaLive(token) {
    const all = await this._getTree(token);
    if (!all.resources) return [];
    return all.resources.filter(item => item.type === this.typeLink);
  },

  /**
   * Save a DeA Live post object
   *
   * @param {*} token : authentication token
   * @param {*} post : DeA Live post
   * @param {*} bookmarkFrom : website source
   */
  async saveDeaLive(token, post, bookmarkFrom) {
    if (!bookmarkFrom && this.debug()) console.log("#### Bookmark origin not set!");
    const savedObject = {
      title: post.title,
      type: this.typeLink,
      data_from: bookmarkFrom,
      origin: bookmarkFrom.code,
      data_url: post.link,
      data_obj_id: post.id,
      data_url_from: document.location.href,
      payload: post,
    };
    const saved = await this._saveObject(token, savedObject);
    if (!saved) return {};
    return saved;
  },

  /**
   * Get the list of events in the root folder
   *
   * @param {*} token : authentication token
   */
  async getEvents(token) {
    const all = await this._getTree(token);
    if (!all.resources) return [];
    return all.resources.filter(item => item.type === this.typeEvent);
  },

  /**
   * Save a formazione event object
   *
   * @param {*} token : authentication token
   * @param {*} event : formazione event
   * @param {*} bookmarkFrom : website source
   */
  async saveEvent(token, event, bookmarkFrom) {
    if (!bookmarkFrom && this.debug()) console.log("#### Bookmark origin not set!");
    const savedObject = {
      title: event.title,
      type: this.typeEvent,
      data_from: bookmarkFrom,
      origin: bookmarkFrom.code,
      data_url: event.event_url,
      data_obj_id: String(event.id),
      data_url_from: document.location.href,
      payload: event,
    };
    const saved = await this._saveObject(token, savedObject);
    if (!saved) return {};
    return saved;
  },

  /**
   * Get the list of events in the root folder
   *
   * @param {*} token : authentication token
   */
  async getBooks(token) {
    const all = await this._getTree(token);
    if (!all.resources) return [];
    return all.resources.filter(item => item.type === this.typeBook);
  },

  /**
   * Save a book object
   *
   * @param {*} token : authentication token
   * @param {*} book : book object
   * @param {*} bookmarkFrom : website source
   */
  async saveBook(token, book, bookmarkFrom) {
    if (!bookmarkFrom && this.debug()) console.log("#### Bookmark origin not set!");
    const savedObject = {
      title: book.title,
      type: ResourceClient.typeBook,
      data_from: bookmarkFrom,
      origin: bookmarkFrom.code,
      data_obj_id: String(book.bsmart_id),
      time_id: String(book.time_id),
      book_id: String(book.bsmart_id),
      data_url_from: document.location.href,
      payload: book,
    };
    const saved = await this._saveObject(token, savedObject);
    if (!saved) return {};
    return saved;
  },

  /**
   * Get the list of events in the root folder
   *
   * @param {*} token : authentication token
   */
  async getTimeBooks(token) {
    const all = await this._getTree(token);
    if (!all.resources) return [];
    return all.resources.filter(item => item.type === this.typeTimeBook);
  },

  /**
   * Save a book object
   *
   * @param {*} token : authentication token
   * @param {*} book : book object
   * @param {*} bookmarkFrom : website source
   */
  async saveTimeBook(token, book, bookmarkFrom) {
    if (!bookmarkFrom && this.debug()) console.log("#### Bookmark origin not set!");
    const bookId = book.time_id ? String(book.time_id) : String(book.id);
    const savedObject = {
      title: book.title,
      type: ResourceClient.typeTimeBook,
      data_from: bookmarkFrom,
      origin: bookmarkFrom.code,
      data_obj_id: bookId,
      time_id: bookId,
      data_url_from: document.location.href,
      payload: book,
    };
    const saved = await this._saveObject(token, savedObject);
    if (!saved) return {};
    return saved;
  },

  /**
   * Get a list of items filtered by origin name
   *
   * @param {*} token : authentication token
   * @param {*} origin : origin string
   * @param {*} callback : method name string to call (i.e. "getResources", "getTimeBooks", etc.)
   */
  async filterByOrigin(token, origin) {
    const filtered = await this._getUserResources(token, origin);
    return filtered;
  },
};

module.exports = ResourceClient;
